import { Component, computed, inject, OnInit, signal } from "@angular/core";
import { TableComponent } from "../../../../components/table/table.component";
import { ActivatedRoute, Router, RouterLink } from "@angular/router";
import { ColumnType, ITableColumn } from "../../../../components/table/table.types";
import { PageTitleComponent } from "../../../../components/page-title/page-title.component";
import { TranslatePipe } from "@ngx-translate/core";
import { NzButtonModule } from "ng-zorro-antd/button";
import { NzFlexModule } from "ng-zorro-antd/flex";
import { DetailRoute, EAuthorizationManagmentRoute, EAuthorizationManagmentViewRightsRoute } from "../../../../constants/routes.constant";
import { AuthorizationsApiClientService, NIASBizBllModelsAuthDocumentInfo, NIASBizBllModelsRoRedisgnDocumentActivityDto, NIASBizBllModelsSignatureInfo } from "../../../../api/v1";
import { AuthorizationInfoContentComponent } from "../../../../components/authorization-info-content/authorization-info-content.component";
import { DatePipe } from "@angular/common";
import { JIPSService } from "../../../../services/jips.service";
import { toSignal } from "@angular/core/rxjs-interop";
import { map } from "rxjs";

@Component({
    selector: 'app-authorization-history-details',
    templateUrl: './authorization-history-details.page.html',
    imports: [
        TableComponent,
        PageTitleComponent,
        TranslatePipe,
        NzButtonModule,
        NzFlexModule,
        RouterLink,
        AuthorizationInfoContentComponent
    ],
    providers: [DatePipe]
})
export class AuthorizationHistoryDetailsPage implements OnInit {
    private authorizationApiClientService: AuthorizationsApiClientService = inject(AuthorizationsApiClientService);
    private activatedRoute = inject(ActivatedRoute);
    private router: Router = inject(Router);
    private datePipe = inject(DatePipe);
    private jipsService = inject(JIPSService);
    public isSupervisorApp = sessionStorage.getItem("supervisorUser") ;

    public documentId = toSignal(this.activatedRoute.paramMap.pipe(map((param) => param.get('docId'))));
    public tableColumns = signal<ITableColumn<NIASBizBllModelsRoRedisgnDocumentActivityDto>[]>([]);
    public tableData = signal<NIASBizBllModelsRoRedisgnDocumentActivityDto[]>([]);
    public authDocumentInfo = signal<NIASBizBllModelsAuthDocumentInfo | null>(null);
    public pathToDetails = computed<string>(() => `/${EAuthorizationManagmentRoute}/${EAuthorizationManagmentViewRightsRoute}/${DetailRoute}/${this.authDocumentInfo()?.AuthDocumentId}`);
    public breadcrumbsForDetails = computed(() => {
        return [
            { 
                label: 'EAUTHORIZATION-MANAGMENT.OVERVIEW-TITLE', 
                path: `/${EAuthorizationManagmentRoute}/${EAuthorizationManagmentViewRightsRoute}/${DetailRoute}/${this.authDocumentInfo()?.AuthDocumentId}`
            },
            {
                label: 'EAUTHORIZATION-MANAGMENT.DETAILS.TITLE',
                path: `/${EAuthorizationManagmentRoute}/${EAuthorizationManagmentViewRightsRoute}/${DetailRoute}/${this.authDocumentInfo()?.AuthDocumentId}`
            },
            {
                label: 'Detalji prava za administraciju e-Ovlaštenja',
                path: null
            }        
        ]  
    });
    
    public ngOnInit(): void {
            console.log(this.isSupervisorApp)
        this.tableColumns.set([
            { 
                header: { key: 'Service', label: 'Potpisnik', type: ColumnType.TEXT },  
                cellValue: (data) => data.Signer || ''
            },
            { 
                header: { key: 'PersonEntity', label: 'Osoba koja je izvršila radnju', type: ColumnType.TEXT }, 
                cellValue: (data) => data.SignedInNameOfSigner || ''
            },
            { 
                header: { key: 'LegalEntity', label: 'Poslovni subjekt s certifikata', type: ColumnType.TEXT }, 
                cellValue: (data) =>  {
                   if(data.CertificateSubject) {
                     return this.jipsService.getJipsData(data.CertificateSubject?.Jips?.IZVOR_REG || 0) + ': ' + (data.CertificateSubject?.Jips?.IPS || '')
                   }else {
                    return ''
                   }
                }
            },
            { 
                header: { key: 'NewState', label: 'Status', type: ColumnType.TEXT }, 
                cellValue: (data) => data.DocumentState || ''
            },
            { 
                header: { key: 'TimeStamp', label: 'Vrijeme promjene statusa', type: ColumnType.DATE }, 
                cellValue: (data) =>  this.datePipe.transform(data.Timestamp, 'dd.MM.yyyy HH:mm:ss') || ''
            }
        ]);

        this.authorizationApiClientService.authorizationsApiGetDocumentInfo(this.documentId() || '').subscribe({
            next: (res) => {
                this.authDocumentInfo.set(res);
                this.authorizationApiClientService.authorizationsApiGetDocumentActivityChanges(this.documentId() || '').subscribe((res: NIASBizBllModelsRoRedisgnDocumentActivityDto[]) => {
                    this.tableData.set(res);
                });
            },
            error: (err: unknown) => {
                this.router.navigate([EAuthorizationManagmentRoute, EAuthorizationManagmentViewRightsRoute]);
            }
        });

    } 

}